import { Card, Table } from "@caprikorn/dynamo-ui";
import type { FetchDataProps } from "@caprikorn/dynamo-ui/lib/components/dataDisplay/Table/Table.types";
import { type FC, useState } from "react";
import { useParams } from "react-router-dom";

import type { UrlParam } from "@router/router.types";
import type {
  GetExpositionPoint,
  Reading,
} from "@services/apiEcms/apiEcms.types";
import { useGetExpositionPoint } from "@services/apiEcms/useGetExpositionPoint";
import { useCustomTranslation } from "@utils/translations/useCustomTranslation";

import { useReadingsColumns } from "./TableReadings.columns";
import type { TableReadingsProps } from "./TableReadings.types";

const initialFilters: FetchDataProps = {
  pageIndex: 0,
  pageSize: 10,
  globalFilter: "",
  columnFilters: [],
  sorting: [],
};
const getRowId = (row: Reading) => row.date;

const selectExpositionPointData = ({
  readingCollection,
  dials,
}: GetExpositionPoint) => ({
  readingCollection,
  dials,
});

export const TableReadings: FC<TableReadingsProps> = ({ energy }) => {
  const { t } = useCustomTranslation("main");
  const {
    contractId = "",
    customerId = "",
    siteId = "",
  } = useParams<UrlParam>();
  const [filters, setFilters] = useState<FetchDataProps>(initialFilters);

  const { data, isError, isPending } = useGetExpositionPoint(
    {
      customerId,
      contractId,
      siteId,
      readingPage: filters.pageIndex + 1,
      elementsPerPage: filters.pageSize,
    },
    {
      select: selectExpositionPointData,
    },
  );
  const columns = useReadingsColumns(energy, data?.dials);
  return (
    <Card data-testid="PerimeterPageSiteLastRecords">
      <Table
        columns={columns}
        data={data?.readingCollection?.readings ?? []}
        fetchData={setFilters}
        getRowId={getRowId}
        initialColumnFilters={initialFilters.columnFilters}
        initialPageIndex={initialFilters.pageIndex}
        initialPageSize={initialFilters.pageSize}
        isError={isError}
        isLoading={isPending}
        totalCount={data?.readingCollection?.pagination?.recordsCount ?? 0}
      >
        <Table.ActionBar.Title title={t("site.reading.title")} />
        <Table.Content />
        <Table.Pagination withPageSizeSelector />
      </Table>
    </Card>
  );
};
